import loadable from '@loadable/component';

export const OrgDasboardViewPaymentPageLoadable = loadable(
  () => import('./OrgDashboardViewPaymentPage'),
  {
    resolveComponent: (module) => module.OrgDashboardViewPaymentPage,
    ssr: false,
  },
);
